import type { ThemeConfig } from 'antd/lib'
import type { MessageInstance, JointContent, ArgsProps } from 'antd/lib/message/interface'
import React from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { ConfigProvider, message } from 'antd'
import Login from './Login'
import Main from './Main'
import MicroMain from './MicroMain'
import { $consts } from 'src/plugins'
import { useEvt } from 'src/hooks'
import zhcn from 'antd/lib/locale/zh_CN'
import 'enasops/styles/layout/main.less'

/**
 * 可以根据路由展示不同的 Layout 组件
 * @param props 
 * @returns 
 */
const Layout = (props: any) => {
  const location = useLocation()

  const [msApi, msContext] = message.useMessage()

  // 接口错误处理
  useEvt($consts['EVT/API_DATA_ERROR'], msApi.error)

  // 消息提示
  useEvt($consts['EVT/POST_MESSAGE'], (msg: JointContent, type: keyof MessageInstance = 'success') => {
    if (type === 'open') {
      msApi.open(msg as ArgsProps)
    } else if (type === 'destroy') {
      msApi.destroy(msg as React.Key)
    } else {
      msApi[type](msg)
    }
  })

  const theme: ThemeConfig = {
    token: { fontSize: 16, colorFillAlter: '#BCC7D8' },
    components: {
      Message: {
        zIndexPopup: 9999
      }
    }
  }

  const matchLogin = matchPath({
    path: $consts['ROUTE/LOGIN'],
  }, location.pathname)

  return (
    <ConfigProvider locale={zhcn} theme={theme}>
      {
        matchLogin
          ? <Login />
          : window.__POWERED_BY_QIANKUN__
            ? <MicroMain />
            : <Main />
      }
      {msContext}
    </ConfigProvider>
  )
}

export default Layout